import { defineComponent as l, ref as i, computed as o, openBlock as p, createElementBlock as c, normalizeClass as r, createElementVNode as a, renderSlot as d } from "vue";
import { _ as f } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
const m = [
  // Layout
  "layout-row !items-start justify-between",
  // Spacing
  "gap-sm",
  // Typography
  "typography-caption-regular",
  // Theme
  "theme-foreground-error",
  "dark:theme-foreground-error-dark"
], u = [
  // Interactivity
  "interactivity-default"
], y = [
  // Layout
  "layout-inline-row empty:hidden",
  // Typography
  "whitespace-nowrap"
], h = l({
  name: "OrError",
  props: {
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  expose: [
    "root"
  ],
  setup() {
    const e = i(), t = o(() => [
      "or-error-v3",
      ...m
    ]), s = o(() => [
      ...u
    ]), n = o(() => [
      ...y
    ]);
    return {
      root: e,
      rootStyles: t,
      textStyles: s,
      addonStyles: n
    };
  }
}), E = ["disabled"];
function S(e, t, s, n, $, b) {
  return p(), c("div", {
    ref: "root",
    class: r(e.rootStyles),
    disabled: e.disabled
  }, [
    a("div", {
      class: r(e.textStyles)
    }, [
      d(e.$slots, "default")
    ], 2),
    a("div", {
      class: r(e.addonStyles)
    }, [
      d(e.$slots, "addon")
    ], 2)
  ], 10, E);
}
const w = /* @__PURE__ */ f(h, [["render", S]]);
export {
  w as O
};
//# sourceMappingURL=OrError-B5ihH6-3.mjs.map
